import { IRoleData } from '../../types/roles/IRole';
import { BaseAPI } from '../BaseApi';
import { eAPITags } from 'API/eAPITags';
import { CACHE_TIME } from '../../utilities/Constants.APIConfig';

export const RolesApi = BaseAPI.injectEndpoints({
  endpoints: (build) => ({
    listRoles: build.query<IRoleData[], void>({
      query: () => `/timber/api/internal/roles`,
      keepUnusedDataFor: CACHE_TIME,
      providesTags: () => [{ type: eAPITags.RoleData }],
    }),
  }),
  overrideExisting: false,
});

export const { useListRolesQuery } = RolesApi;
